export default __webpack_public_path__ + "static/media/most-delicious.a96fd501.jpg";